import { Globe } from "lucide-react";
import { Reveal, SectionTag, SectionHeading } from "./Reveal";
import { ASSETS } from "../lib/site";

const CLIENTS = [
  {
    name: "Stran Promotional Solutions",
    country: "USA",
    logo: ASSETS.clientStran,
    dark: false,
    testId: "client-logo-stran-usa",
  },
  {
    name: "Impact Marketing",
    country: "Canada",
    logo: ASSETS.clientImpact,
    dark: false,
    testId: "client-logo-impact-canada",
  },
  {
    name: "BLVD",
    country: "Canada",
    logo: ASSETS.clientBlvd,
    dark: true,
    testId: "client-logo-blvd-canada",
  },
];

const Clients = () => (
  <section id="clients" className="bg-[#F8FAFC] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionTag index="04" label="Our Clients" testId="clients-section-tag" />
      <div className="mt-6 max-w-2xl">
        <SectionHeading>Trusted by leading distributors</SectionHeading>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {CLIENTS.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.12}>
            <div
              data-testid={c.testId}
              className="group flex h-full flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white px-8 py-12 text-center transition-all duration-500 hover:-translate-y-1.5 hover:border-[#6DC8F0]/40"
            >
              {c.logo ? (
                <div
                  className={`flex h-24 w-full items-center justify-center rounded-xl px-6 py-4 ${
                    c.dark ? "bg-[#1A1A1A]" : "border border-slate-200 bg-white"
                  }`}
                >
                  <img
                    src={c.logo}
                    alt={`${c.name} logo`}
                    className="max-h-16 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              ) : (
                <span className="font-display text-4xl font-extrabold tracking-[0.12em] text-slate-700 transition-colors duration-500 group-hover:text-[#2E3192]">
                  {c.name}
                </span>
              )}
              <span className="mt-5 text-sm text-slate-500">{c.name}</span>
              <span className="mt-3 flex items-center gap-1.5 rounded-full border border-slate-200 px-3 py-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-500">
                <Globe className="h-3 w-3 text-[#2E3192]" />
                {c.country}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Clients;
